import React from "react";
import _ from "lodash";
import { renderLayout } from "schema/ThemeSet.react";
import OptionPicture from "slides/components/OptionPicture.react";

export default class SingleSelect extends React.Component {
    handleClick = (index) => {
        this.props.trackInteraction(index);
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);

        let mappedOptions = _.map(
            this.props.data.imageOpts,
            (option, index) => {
                let isEven = this.props.data.imageOpts.length % 2 === 0;
                return (
                    <OptionPicture
                        {...this.props}
                        fluid
                        index={index}
                        key={"button-" + index}
                        layout={isEven ? "grid" : this.props.layout}
                        image={option.image}
                        handleClick={this.handleClick}
                    />
                );
            }
        );
        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    title={"Choose an option:"}
                    mainContent={mappedOptions}
                />
            </div>
        );
    }
}
